import React from 'react';
import './Header.scss';
import Logo from '@assets/images/logo/logo-cosem.svg?react';

import { useHeaderVM } from './useHeaderVM';
import { PageTitle } from '@components/PageTitle/PageTitle';
import { Button } from '@design-system/components/Buttons/Button/Button';
import { useNavigate } from 'react-router-dom';

export const Header: React.FC = () => {
    const { handleLogoutClick } = useHeaderVM();
    const navigate = useNavigate();
    return (
        <header className="header">
            <div className="logo" onClick={() => navigate('/')}>
                <Logo />
            </div>
            <div className="right-end">
                <div className="header-page-title">
                    <PageTitle />
                </div>
                <div className="user-options">
                    <div className="actions">
                        <Button variant="secondary" onClick={handleLogoutClick}>
                            Déconnexion
                        </Button>
                    </div>
                </div>
            </div>
        </header>
    );
};
